"use client";

import { VideoCard } from "@/components/video/video-card/video-card";
import { canInstantImageLoad } from "@/service/image/image-load";
import { AsideList } from "@/components/common/aside-list";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export const AsidePlaylistVideos = ({
  video,
  videos,
  playlist,
  episodeNumber,
}: {
  video: VideoVM;
  videos: PlaylistEpisodePreviewVM[];
  playlist: PlaylistVM;
  episodeNumber: number;
}) => {
  const videosOrdered = playlist.isSeries
    ? structuredClone(videos).reverse()
    : videos;
  const [opacity, setOpacity] = useState(false);

  useEffect(() => {
    const activeElement =
      document.querySelector(`#part-${episodeNumber}`) ??
      document.querySelector(`#part-1`);

    // Scroll to the active element
    if (window.innerWidth > 1280) {
      activeElement?.scrollIntoView({
        behavior: "smooth",
        block: "center", // Vertical centering in the viewport
        inline: "center", // might not be needed for vertical lists
      });
    }

    setTimeout(() => {
      setOpacity(true);
    }, 1000);
  }, [video.id]);

  return (
    <div
      className={cn(
        `transition-duration-1000 transition-all`,
        opacity ? "opacity-100" : "opacity-0",
      )}
    >
      <AsideList
        activeIndex={videosOrdered.findIndex(
          ({ episodeNumber: epNumber }) => epNumber === episodeNumber,
        )}
        items={videosOrdered.map((data, index) => (
          <VideoCard
            aside={true}
            key={data.title}
            active={data.id === video.id}
            instantImageLoad={canInstantImageLoad(6, index)}
            data={data}
            episodeNumber={data.episodeNumber}
          />
        ))}
      />
    </div>
  );
};
